import React from 'react'
import { connect } from 'react-redux'
import { getTermsAcceptanceLogs } from '../../redux/actions/termsAcceptanceLogsActions'
import { getTranslate } from 'react-localize-redux'
import TermsAcceptanceLogsView from '../../components/terms-acceptance-logs'

class TermsAcceptanceLogsPage extends React.Component {
  state = {
    currentPage: 1,
    pageSize: 50
  }

  componentDidMount() {
    this.fetchLogs()
  }

  fetchLogs = () => {
    const { getTermsAcceptanceLogs } = this.props
    const { currentPage, pageSize } = this.state
    getTermsAcceptanceLogs(currentPage, pageSize)
  }

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber }, this.fetchLogs)
  }

  render() {
    const { termsAcceptanceLogs, translate } = this.props
    const { currentPage } = this.state

    return (
      <TermsAcceptanceLogsView
        termsAcceptanceLogs={termsAcceptanceLogs}
        translate={translate}
        currentPage={currentPage}
        onPageChange={this.handlePageChange}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    termsAcceptanceLogs: state.termsAcceptanceLogsReducer || {
      termsAcceptanceLogs: {
        data: [],
        pagination: {
          pageNumber: 1,
          pageSize: 50,
          totalCount: 0,
          totalPages: 0
        }
      },
      loading: false,
      error: null
    },
    translate: getTranslate(state.localeReducer)
  }
}

const mapDispatchToProps = {
  getTermsAcceptanceLogs
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsAcceptanceLogsPage)
